import React, { useEffect, useRef, useState } from 'react';
import Loader from '../Loader';
import './style.scss';

interface Props {
    uri: string;
    maxHeight?: number;
    percentualToEnd?: number;
    onLoad?: CallableFunction;
    onScrollEnd?: CallableFunction;
}

const CustomWebView: React.FC<Props> = (props: Props) => {
    const { uri, maxHeight = 0, percentualToEnd = 70, onLoad, onScrollEnd } = props;
    const [loading, setLoading] = useState<boolean>(true);
    const [done, setDone] = useState<boolean>(false);
    const [webviewHeight, setWebviewHeight] = useState<number>(maxHeight);

    const iframeRef = useRef<HTMLIFrameElement>(null);
    const htmlPlayerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const handleResize = () => {
        const iframe = iframeRef.current;

        if (
            iframe &&
            iframe.contentWindow &&
            iframe.contentWindow.document &&
            iframe.contentWindow.document.body &&
            iframe.contentWindow.document.body.parentElement &&
            iframe.contentWindow.document.body.parentElement.offsetHeight > 0
        ) {
            setWebviewHeight(iframe.contentWindow.document.body.parentElement.offsetHeight);
            calculatePercent();
        } else {
            setTimeout(handleResize, 400);
        }
    };

    useEffect(() => {
        const scrollableElement = maxHeight > 0 ? htmlPlayerRef.current : window;

        if (scrollableElement) {
            scrollableElement.addEventListener('scroll', calculatePercent);
        }

        return () => {
            if (scrollableElement) {
                scrollableElement.removeEventListener('scroll', calculatePercent);
            }
        };
    }, [uri]);

    const calculatePercent = () => {
        const htmlPlayer = maxHeight > 0 ? htmlPlayerRef.current : (window.document.documentElement as HTMLElement);
        if (htmlPlayer) {
            const percent = ((htmlPlayer.scrollTop + htmlPlayer.clientHeight) / htmlPlayer.scrollHeight) * 100;
            if (!done && (htmlPlayer.scrollHeight <= htmlPlayer.clientHeight || percent >= percentualToEnd)) {
                setDone(true);
            }
        }
    };

    useEffect(() => {
        if (done && onScrollEnd) {
            onScrollEnd();
        }
    }, [done]);

    return (
        <>
            {loading && <Loader />}
            <div className="html-player" id="html-player" ref={htmlPlayerRef} style={{ height: maxHeight || undefined }}>
                <iframe
                    className={`${loading ? 'hide' : ''}`}
                    onLoad={() => {
                        if (onLoad) {
                            onLoad();
                        }
                        setLoading(false);
                        handleResize();
                    }}
                    ref={iframeRef}
                    scrolling="no"
                    src={uri}
                    style={{ height: webviewHeight }}
                />
            </div>
        </>
    );
};

export default CustomWebView;
